import script from "./QOfflineBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./QOfflineBanner.vue?vue&type=script&lang=ts&setup=true"

import "./QOfflineBanner.vue?vue&type=style&index=0&id=87e58fc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87e58fc4"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon});
